<template>
    <div id="contenedro-principal" class="conatainer-fluid">
        <div id="contenedor-descripcion" class="row">
            <div id="descripcion-texto" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pt-2 pl-2 pr-2">
                <div id="texto">
                    <h1>{{ opciones.tituloBusqueda }}</h1>
                    <h2><i class="fas fa-exclamation"></i>&nbsp;Sin resultados</h2>
                    <div class="mt-4">
                        <h6>No se encontraron registros en la búsqueda de contenidos para la sección <strong>{{ opciones.NombreSeccion }}</strong></h6>
                    </div>
                </div>
            </div>
            <div id="descripcion-imagen" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pt-2 pl-2 pr-2">
                <div id="contenedor-imagen-compuesta">
                    <div id="imagen-folder">
                        <i class="fas fa-folder-open"></i>
                    </div>
                    <div id="imagen-error">
                        <i class="fas fa-times-circle"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        opciones: {
            type: Object,
            default: () => ({
                tituloBusqueda: 'Busqueda en documentos',
                NombreSeccion: 'Documentos'
            })
        }
    },
    data() {
        return {
            
        }
    },
}
</script>
<style scoped>
    #contenedor-imagen-compuesta {
        position: relative;
        border: 1px solid rgb(211, 211, 211);;
        background-color: rgb(223, 223, 223);
        border-radius: 3px;
    }

    #imagen-folder {
        display: flex;
        justify-content: center;
        left: 30%;
    }

    #imagen-folder i {
        font-size: 30vmin;
        color: rgb(116, 116, 116);
    }

    #imagen-error {
        position: absolute; 
        left: 57%;
        top: 65%;
    }

    #imagen-error i {
        font-size: 8vmin;
        color: rgb(131, 15, 15);
    }

    #contenedro-principal {
        background-color: rgb(233, 233, 233);
        box-shadow: 0px 2px 9px 2px #757575;
        padding: 2em 2em 2em 2em;
        border-radius: 3px;
    }

    #texto {
        padding: 0 1em 0 1em;
    }

    #texto h1 {
        color: rgb(129, 129, 129);
        font-weight: bolder;
        font-size: 6.5vmin;
    }

    #texto h2 {
        color: rgb(216, 75, 75);
        font-weight: bold;
        font-size: 5vmin;
    }

    #texto h6 {
        color: rgb(148, 148, 148);
        font-size: 3vmin;
    }
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Comun/CNoSeEncontraronResultados.vue